import Button from 'components/gruenland/atoms/button/Button';
import { LANGUAGE_NAMES } from 'project.config';

type Props = {
  language: string;
  onClick: () => void;
};
const LanguageButton: React.FC<Props> = ({ language, onClick }) => {
  return (
    <Button variant="buttonSecondary" onClick={onClick}>
      {LANGUAGE_NAMES[language]}
    </Button>
  );
};
export default LanguageButton;
